import React from 'react';
import '../css/video-lightbox.css'






class VideoLightbox extends React.Component{




  constructor(props) {

      super(props);

      this.state = {
        videoURL: (this.props.videoURL ? this.props.videoURL : "https://player.vimeo.com/video/241897376?title=0&amp;byline=0&amp;portrait=0")
      }
    }

render(){

  return (
  <div className={ this.props.visible ?"visible video-lightbox":"video-lightbox"} onClick={this.props.close}>

    {  this.props.visible&&(  this.props.calendly?this.props.calendly:(<iframe src={this.state.videoURL} width="720" height="405" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>))}
      </div>
  )};
};

export default VideoLightbox;
